import { Sparkles } from "lucide-react";
import WaitlistForm from "./WaitlistForm";
import PhoneMockup from "./PhoneMockup";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden pt-8 pb-24 sm:pt-12 sm:pb-32"
      style={{ background: "var(--fp-cream)" }}
    >
      {/* Decorative blobs */}
      <div
        className="fp-blob"
        style={{
          width: 420,
          height: 420,
          top: -120,
          left: -120,
          background: "var(--fp-powder)",
        }}
      />
      <div
        className="fp-blob"
        style={{
          width: 340,
          height: 340,
          bottom: -140,
          right: -80,
          background: "var(--fp-rose-gold)",
          opacity: 0.35,
        }}
      />

      <div className="relative max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1.15fr_1fr] gap-12 lg:gap-8 items-center">
        <div className="relative z-10">
          {/* Coming soon badge */}
          <div
            data-testid="coming-soon-badge"
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-[0.16em] animate-fade-up"
            style={{
              background: "rgba(201, 147, 131, 0.18)",
              color: "var(--fp-cognac)",
              border: "1px solid rgba(201, 147, 131, 0.4)",
            }}
          >
            <Sparkles size={14} strokeWidth={2.2} />
            L'application arrive bientôt
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display font-semibold mt-6 text-4xl sm:text-5xl lg:text-6xl leading-[1.02] animate-fade-up delay-100"
            style={{ color: "var(--fp-espresso)" }}
          >
            Ton intestin mérite{" "}
            <span
              className="italic"
              style={{
                background:
                  "linear-gradient(120deg, var(--fp-rose-gold) 0%, var(--fp-terracotta) 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              un journal de bord
            </span>
            .
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-6 text-base sm:text-lg max-w-xl animate-fade-up delay-200"
            style={{ color: "var(--fp-ink-soft)", lineHeight: 1.6 }}
          >
            Que tu aies un diagnostic ou juste un ventre qui décide pour toi,
            Floppy Poopy est fait pour toi. Note tes selles, tes symptômes et
            tes repas en quelques secondes — et commence enfin à voir ce que
            ton corps essaie de te dire.
          </p>

          <div
            className="mt-8 animate-fade-up delay-300"
            id="waitlist"
          >
            <WaitlistForm variant="hero" />
          </div>

          <p
            className="mt-4 text-xs animate-fade-up delay-400"
            style={{ color: "var(--fp-ink-muted)" }}
          >
            🔒 Aucune pub. Un seul email : celui du lancement.
          </p>
        </div>

        {/* Phone mockup */}
        <div className="relative z-10 flex justify-center lg:justify-end">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
}
